export function Divider({ classes }: { classes?: string }) {
  return <div className={`border-b border-gray-100 ${classes}`} />;
}
